import { validarCIF, validarDNI, validarNIE } from '../../../../functions/documentType';

const useUsuarioValidation = (
  setErrorPart1,
  setErrorPart2,
  setErrorPart3,
  setErrorPart4,
  age,
  formationCenter,
) => {
  const validate = (values) => {
    // Seteamos los bloques de errores
    setErrorPart1(false);
    setErrorPart2(false);
    setErrorPart3(false);
    setErrorPart4(false);

    const errors = {};

    /** DATOS PERSONALES */

    // Validamos el nombre
    if (!values.nombre) {
      errors.nombre = 'Obligatorio';
      setErrorPart1(true);
    } else if (!/^(?![\s.]+$)[a-zA-ZÀ-ÿ\s.]*$/i.test(values.nombre.trim())) {
      errors.nombre = 'Nombre incorrecto';
      setErrorPart1(true);
    }

    // Validamos apellidos
    if (!values.apellidos) {
      errors.apellidos = 'Obligatorio';
      setErrorPart1(true);
    } else if (!/^(?![\s.]+$)[a-zA-ZÀ-ÿ\s.]*$/i.test(values.apellidos.trim())) {
      errors.apellidos = 'Apellidos incorrectos';
      setErrorPart1(true);
    }

    // Validamos el tipo de documento
    if (values.tipoDocumento === '-1') {
      errors.tipoDocumento = 'Obligatorio';
      setErrorPart1(true);
    }

    // Validamos el documento
    if (!values.documento) {
      errors.documento = 'Obligatorio';
      setErrorPart1(true);
    } else if (values.tipoDocumento === '0' && !validarDNI(values.documento)) {
      errors.documento = 'Formato incorrecto';
      setErrorPart1(true);
    } else if (values.tipoDocumento === '1' && !validarNIE(values.documento)) {
      errors.documento = 'Formato incorrecto';
      setErrorPart1(true);
    } else if (values.tipoDocumento === '3' && !validarCIF(values.documento)) {
      errors.documento = 'Formato incorrecto';
      setErrorPart1(true);
    }

    // Validamos la fecha de nacimiento
    if (!values.fechaNacimiento) {
      errors.fechaNacimiento = 'Obligatorio';
      setErrorPart1(true);
    }

    // Validamos el país de residencia
    if (!values.pais) {
      errors.pais = 'Obligatorio';
      setErrorPart1(true);
    }

    // Validamos la provincia de residencia
    if (!values.provincia && values.pais === 'España') {
      errors.provincia = 'Obligatorio';
      setErrorPart1(true);
    }

    // Validamos el municipio de residencia
    if (!values.municipio && values.pais === 'España') {
      errors.municipio = 'Obligatorio';
      setErrorPart1(true);
    }

    // Validamos el código postal
    if (!values.cp && values.pais === 'España') {
      errors.cp = 'Obligatorio';
      setErrorPart1(true);
    }

    // Validamos el código postal
    if (values.conocer === 0 || values.conocer === '0') {
      errors.conocer = 'Obligatorio';
      setErrorPart1(true);
    }

    // Validamos el domicilio
    if (!values.domicilio) {
      errors.domicilio = 'Obligatorio';
      setErrorPart1(true);
    }

    // Validamos el país de nacimiento
    if (!values.paisNacimiento) {
      errors.paisNacimiento = 'Obligatorio';
      setErrorPart1(true);
    } else if (values.paisNacimiento !== 'España') {
      values.provinciaNacimiento = '';
      values.municipioNacimiento = '';
    }

    // Validamos la provincia de nacimiento
    if (values.paisNacimiento === 'España' && !values.provinciaNacimiento) {
      errors.provinciaNacimiento = 'Obligatorio';
      setErrorPart1(true);
    }

    // Validamos el municipio de nacimiento
    if (values.paisNacimiento === 'España' && !values.municipioNacimiento) {
      errors.municipioNacimiento = 'Obligatorio';
      setErrorPart1(true);
    }

    // Validamos la nacionalidad
    if (!values.nacionalidad) {
      errors.nacionalidad = 'Obligatorio';
      setErrorPart1(true);
    }

    // Validamos el número de la seguridad social (no obligatorio)
    if (values.nss.toString().length > 0 && values.nss.toString().length !== 12) {
      errors.nss = 'Longitud incorrecta';
      setErrorPart1(true);
    }

    // Validamos el centro
    if (values.centro === '') {
      values.centro = formationCenter[0]?.Nombre || '-1';
      setErrorPart1(true);
    }
    if (values.centro === '-1') {
      errors.centro = 'Obligatorio';
      setErrorPart2(true);
    }

    // Validamos el sexo
    if (values.sexo === '0') {
      errors.sexo = 'Obligatorio';
      setErrorPart1(true);
    }

    // Validamos el email personal
    if (!values.emailPers) {
      errors.emailPers = 'Obligatorio';
      setErrorPart1(true);
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.emailPers)) {
      errors.emailPers = 'Email incorrecto';
      setErrorPart1(true);
    }

    // Validamos el teléfono (no obligatorio)
    if (values.telefono.length > 0 && !/^\d{9}$/i.test(values.telefono)) {
      errors.telefono = 'Teléfono incorrecto';
      setErrorPart1(true);
    }

    // Validamos el móvil
    if (!values.movil) {
      errors.movil = 'Obligatorio';
      setErrorPart1(true);
    } else if (!/^\d{9}$/i.test(values.movil)) {
      errors.movil = 'Móvil incorrecto';
      setErrorPart1(true);
    }

    /** DATOS ESCOLARES */

    // Validamos el idioma
    if (values.idioma === '') {
      errors.idioma = 'Obligatorio';
      setErrorPart2(true);
    }

    // Validamos el sede examen
    if (!values.sede) {
      errors.sede = 'Obligatorio';
      setErrorPart2(true);
    }

    // Validamos la nota media (no obligatorio)
    if (values.notaMedia.toString().length > 0 && !/^\d*\.?\d+$/i.test(values.notaMedia)) {
      errors.notaMedia = 'Debe ser un valor decimal separado por un punto';
      setErrorPart2(true);
    }

    // Validamos los estudios siguientes
    if (!values.siguientesEstudios) {
      errors.siguientesEstudios = 'Obligatorio';
      setErrorPart2(true);
    }

    // Validamos la forma de acceso
    if (values.formaAcceso === '-1') {
      errors.formaAcceso = 'Obligatorio';
      setErrorPart2(true);
    }

    /**
     * TUTORES
     * PRIMER TUTOR
     */

    // Validación del nombre del primer tutor
    if (!values.nombreTutor && age < 18) {
      errors.nombreTutor = 'Obligatorio';
      setErrorPart3(true);
    } else if (
      values.nombreTutor &&
      !/^(?![\s.]+$)[a-zA-ZÀ-ÿ\s.]*$/i.test(values.nombreTutor.trim())
    ) {
      errors.nombreTutor = 'Nombre incorrecto';
      setErrorPart3(true);
    }

    // Validación de los apellidos del primer tutor
    if (!values.apellido1Tutor && age < 18) {
      errors.apellido1Tutor = 'Obligatorio';
      setErrorPart3(true);
    } else if (
      values.apellido1Tutor &&
      !/^(?![\s.]+$)[a-zA-ZÀ-ÿ\s.]*$/i.test(values.apellido1Tutor.trim())
    ) {
      errors.apellido1Tutor = 'Apellido incorrecto';
      setErrorPart3(true);
    }

    if (!values.apellido2Tutor && age < 18) {
      errors.apellido2Tutor = 'Obligatorio';
      setErrorPart3(true);
    } else if (
      values.apellido2Tutor &&
      !/^(?![\s.]+$)[a-zA-ZÀ-ÿ\s.]*$/i.test(values.apellido2Tutor.trim())
    ) {
      errors.apellido2Tutor = 'Apellido incorrecto';
      setErrorPart3(true);
    }

    // Validación del teléfono del primer tutor (no obligatorio)
    if (
      !/^9\d{8}$/i.test(values.telefonoTutor.trim()) &&
      values.telefonoTutor.toString().length > 1
    ) {
      errors.telefonoTutor = 'Teléfono incorrecto';
      setErrorPart3(true);
    }

    // Validación del movil del primer tutor
    if (!values.movilTutor && age < 18) {
      errors.movilTutor = 'Obligatorio';
      setErrorPart3(true);
    } else if (
      !/^[6-7]\d{8}$/i.test(values.movilTutor.trim()) &&
      values.movilTutor.toString().length > 1
    ) {
      errors.movilTutor = 'Móvil incorrecto';
      setErrorPart3(true);
    }

    // Validación del correo electrónico del primer tutor
    if (!values.emailTutor && age < 18) {
      errors.emailTutor = 'Obligatorio';
      setErrorPart3(true);
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.emailTutor) &&
      values.emailTutor.toString().length > 1
    ) {
      errors.emailTutor = 'Email incorrecto';
      setErrorPart3(true);
    }

    // Validación del tipo de documento del primer tutor
    if (values.tipoDocumentoTutor === '-1' && age < 18) {
      errors.tipoDocumentoTutor = 'Obligatorio';
      setErrorPart3(true);
    }

    // Validación del documento del primer tutor
    if (!values.documentoTutor && age < 18) {
      errors.documentoTutor = 'Obligatorio';
      setErrorPart3(true);
    } else if (values.tipoDocumentoTutor === '0') {
      if (
        validarDNI(values.documentoTutor) === false &&
        values.documentoTutor.toString().length > 0
      ) {
        errors.documentoTutor = 'Formato incorrecto';
        setErrorPart3(true);
      }
    } else if (values.tipoDocumentoTutor === '1') {
      if (
        validarNIE(values.documentoTutor) === false &&
        values.documentoTutor.toString().length > 0
      ) {
        errors.documentoTutor = 'Formato incorrecto';
        setErrorPart3(true);
      }
    } else if (values.tipoDocumentoTutor === '3') {
      if (
        validarCIF(values.documentoTutor) === false &&
        values.documentoTutor.toString().length > 0
      ) {
        errors.documentoTutor = 'Formato incorrecto';
        setErrorPart3(true);
      }
    }

    // Validación del parentesco del primer tutor
    if (values.parentescoTutor === '0' && age < 18) {
      errors.parentescoTutor = 'Obligatorio';
      setErrorPart3(true);
    }

    /**
     * TUTORES
     * SEGUNDO TUTOR
     */

    // Validación del nombre del segundo tutor (no obligatorio)
    if (values.nombreTutor2 && !/^(?![\s.]+$)[a-zA-ZÀ-ÿ\s.]*$/i.test(values.nombreTutor2.trim())) {
      errors.nombreTutor2 = 'Nombre incorrecto';
      setErrorPart4(true);
    }

    // Validación de los apellidos del segundo tutor (no obligatorio)
    if (
      values.apellido1Tutor2 &&
      !/^(?![\s.]+$)[a-zA-ZÀ-ÿ\s.]*$/i.test(values.apellido1Tutor2.trim())
    ) {
      errors.apellido1Tutor2 = 'Apellido incorrecto';
      setErrorPart4(true);
    }
    if (
      values.apellido2Tutor2 &&
      !/^(?![\s.]+$)[a-zA-ZÀ-ÿ\s.]*$/i.test(values.apellido2Tutor2.trim())
    ) {
      errors.apellido2Tutor2 = 'Apellido incorrecto';
      setErrorPart4(true);
    }

    // Validación del teléfono del segundo tutor (no obligatorio)
    if (
      !/^9\d{8}$/i.test(values.telefonoTutor2.trim()) &&
      values.telefonoTutor2.toString().length > 1
    ) {
      errors.telefonoTutor2 = 'Teléfono incorrecto';
      setErrorPart4(true);
    }

    // Validación del movil del segundo tutor (no obligatorio)
    if (
      !/^[6-7]\d{8}$/i.test(values.movilTutor2.trim()) &&
      values.movilTutor2.toString().length > 1
    ) {
      errors.movilTutor2 = 'Móvil incorrecto';
      setErrorPart4(true);
    }

    // Validación del correo electrónico del segundo tutor (no obligatorio)
    if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.emailTutor2) &&
      values.emailTutor2.toString().length > 1
    ) {
      errors.emailTutor2 = 'Email incorrecto';
      setErrorPart4(true);
    }

    // Validación del tipo de documento del segundo tutor (no obligatorio)
    if (values.tipoDocumentoTutor2 === '0') {
      if (
        validarDNI(values.documentoTutor2) === false &&
        values.documentoTutor2.toString().length > 0
      ) {
        errors.documentoTutor2 = 'Formato incorrecto';
        setErrorPart4(true);
      }
    } else if (values.tipoDocumentoTutor2 === '1') {
      if (
        validarNIE(values.documentoTutor2) === false &&
        values.documentoTutor2.toString().length > 0
      ) {
        errors.documentoTutor2 = 'Formato incorrecto';
        setErrorPart4(true);
      }
    } else if (values.tipoDocumentoTutor2 === '3') {
      if (
        validarCIF(values.documentoTutor2) === false &&
        values.documentoTutor2.toString().length > 0
      ) {
        errors.documentoTutor2 = 'Formato incorrecto';
        setErrorPart4(true);
      }
    }

    // Validación del parentesco del segundo tutor
    if (values.parentescoTutor2 === '0' && values.nombreTutor2 !== '') {
      errors.parentescoTutor2 = 'Obligatorio';
      setErrorPart3(true);
    }

    // Devolvemos los errores
    return errors;
  };

  return { validate };
};

export default useUsuarioValidation;
